import { AppointmentNotaryType, IAppointment } from 'types/appointments';
import { ITransactionType } from 'types/services';

export const getPaymentText = (appointment?: IAppointment, transactionTypesData?: ITransactionType[]) => {
  if (!appointment) {
    return { clientPrice: 0, notaryPrice: 0 };
  }
  const notarySpecificPrices: { priceInPerson?: number; priceRON?: number } =
    transactionTypesData?.find((transType) => transType.id === appointment?.transaction?.transactionType.id)
      ?.userPrice || {};
  const isAppointmentInPerson = appointment.type === AppointmentNotaryType.IN_PERSON;
  const clientPrice = isAppointmentInPerson ? appointment.clientInPersonFee : appointment.clientRONFee;
  const notaryPrice = isAppointmentInPerson
    ? notarySpecificPrices?.priceInPerson || appointment.notaryGetInPerson || undefined
    : notarySpecificPrices?.priceRON || appointment.notaryGetRON || undefined;
  return { clientPrice, notaryPrice };
};
